// extracted by css-extract-rspack-plugin
export default {"chip":"chip-SCmsHT","success":"success-zTATZd","danger":"danger-HCoEKs","warning":"warning-LpviZH","info":"info-NkgoAq","secondary":"secondary-uO4xlm"};